// "Install as an app" support. Chrome and Edge fire `beforeinstallprompt` once
// the site qualifies; we hold on to it so the command palette can offer
// installation on demand. Importing this module early (see index.js) means the
// event is never missed.
let deferredPrompt = null;
const listeners = new Set();
const notify = () => listeners.forEach((listener) => listener(deferredPrompt !== null));

if (typeof window !== 'undefined') {
    window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault();
        deferredPrompt = event;
        notify();
    });
    window.addEventListener('appinstalled', () => {
        deferredPrompt = null;
        notify();
    });
}

export const canInstall = () => deferredPrompt !== null;

export const onInstallChange = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
};

// Resolves to 'accepted' | 'dismissed' | 'unavailable'.
export async function promptInstall() {
    if (!deferredPrompt) return 'unavailable';
    const event = deferredPrompt;
    deferredPrompt = null;
    notify();
    event.prompt();
    const choice = await event.userChoice;
    return choice.outcome;
}
